import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./QRView.css";
//import FlyingRavanaLogo from "/FlyingRavanaLogo.jpg"; // Make sure this file is in the public folder

const QRVIEW = () => {
  const { trackingId } = useParams();
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchQRData = async () => {
      try {
        setLoading(true);
        setError("");
        setQrData(null);
        const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
        const response = await axios.get(
          `${apiBaseUrl}/api/public/assets/${encodeURIComponent(trackingId.trim())}`
        );
        setQrData(response.data);
      } catch (error) {
        console.error("Error fetching QR data:", error);
        setError(
          error.response?.status === 404
            ? "No asset found for this Tracking ID."
            : "Unable to load asset details. Please try scanning again."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchQRData();
  }, [trackingId]);

  // Dynamically change background image
  const viewStyle = {
    backgroundImage: /^uhe exports?$/i.test((qrData?.company || "").trim().replace(/\s+/g, " "))
    ? "linear-gradient(rgba(255, 255, 255, 0.78), rgba(255, 255, 255, 0.78)), url('/brands/halpe.jpeg')"
    : qrData?.company === "Vella" 
    ? `url('/vellalogo.jpg')` 
    : qrData?.company === "98 Acres" 
    ? `url('/98.png')`
    : qrData?.company === "Ravana Pool Club" 
    ? `url('/RPC.png')` 
    : qrData?.company === "Flying Ravana" 
    ? `url('/FR.png')` 
    : qrData?.company === "Le Maas Tota" 
    ? `url('/lee.png')` 
    : qrData?.company === "Tea Factory" 
    ? `url('/tea.png')` 
    : qrData?.company === "Walaa kulu" 
    ? `url('/vala.png')` 
    : qrData?.company === "kiri kopi" 
    ? `url('/kirikopi.jpg')`
    : qrData?.company === "Ella Swing" 
    ? `url('/swing.png')`  
    : "none",

    backgroundSize: '200px',
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    boxShadow: "0px 4px 10px rgba(10, 10, 10, 0.6)",  // Adds a shadow around the element
    filter: "drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.6))", // Alternative method using filter 
     

    
  };

 


  return (
    <div className="MainView" style={{ backgroundImage: `url('/Vella.jpg')`, backgroundSize: "cover", backgroundPosition: "center" }}>
      <div className="View" >
        <h1 className="headQR">Scanned QR</h1>

{/* Transfer Subtitle */}
{qrData?.assetTransferDate && (
  <h5 className="transfer-subtitle">
     This asset is a Transferred Asset
  </h5>
)}
        {loading ? (
          <p>Loading QR Data...</p>
        ) : error ? (
          <p>{error}</p>
        ) : qrData ? (
          <div className="details" style={viewStyle}>
            <p><strong>Category:</strong> {qrData.category}</p>
            <p><strong>Type:</strong> {qrData.type}</p>
            <p><strong>Asset Name:</strong> {qrData.assetName}</p>

           
            <p><strong>Tracking ID:</strong> {qrData.trackingId}</p>
            <p><strong>Company:</strong> {qrData.company}</p>
            <p><strong>Department:</strong> {qrData.department}</p>
            <p><strong>EPF No & Recipient Name</strong> {qrData.assetUserName}</p>
            <p><strong>Asset Model:</strong> {qrData.assetModel}</p>
            <p><strong>Serial Number:</strong> {qrData.serialNumber}</p>
            <p><strong>Register Date</strong> {qrData.assetUpdateDate}</p>
            {qrData?.assetTransferDate && (
  <p><strong>Transfer Date: </strong> {qrData.assetTransferDate}</p>
)}
            <p><strong>Asset Image: </strong>{qrData.assetImageURL ? (
                        <a
                          href={qrData.assetImageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Image
                        </a>
                      ) : (
                        "No Image"
                      )}</p>
             
            
          </div>
        ) : (
          <p>No asset found for this Tracking ID.</p>
        )}
      </div>
    </div>
  );
};

export default QRVIEW;
